import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import router from './router'
import './assets/css/bootstrap.min.css'
import 'vue-toast-notification/dist/theme-default.css'
import './assets/css/toast.css'
import VueToast from 'vue-toast-notification'
import Vue2Editor from 'vue2-editor'
import http, { API_URL, BACK_URL } from './api/http'
import i18n from './i18n'

Vue.config.productionTip = false
Vue.prototype.$axios = http
Vue.prototype.$API_URL = API_URL
Vue.prototype.$BACK_URL = BACK_URL
Vue.prototype.$API_VERSION = 'v1/'
Vue.prototype.$API_VERSION_2 = process.env.VUE_APP_API_VERSION_2
Vue.prototype.$API_MAIN = process.env.VUE_APP_API

Vue.use(VueToast)
Vue.use(Vue2Editor)

new Vue({
  store,
  vuetify,
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
